
import React, { useMemo, useState } from 'react';
import Papa from 'papaparse'; 
import {DashboardApi} from '../../services/api';
import { Carrera, Materia, Universidad } from '../../objetos/objeto_materias';
import { useLoading } from '../../utils/LoadingProvider';
import { convertirFechaFirebase } from '../../objetos/utiles_objetos';
import { ServicioAgendado } from '../../objetos/objeto_servicio';

export const useDashboardModel = () => {
    const { showLoading, hideLoading, withLoading } = useLoading();

    //proPlataforma UNAD
    const [estadisticasProUnad, setestadisticasProUnad] = useState([]);
    const [LoadingestadisticasProUnad, setLoadingestadisticasProUnad] = useState(false);
    const [errorestadisticasProUnad, setErrorestadisticasProUnad] = useState(null);

    //trabajos no entregados
    const [estadisticasTrabajosNoEntregados, setestadisticasTrabajosNoEntregados] = useState([]);
    const [LoadingestadisticasTrabajosNoEntregados, setLoadingestadisticasTrabajosNoEntregados] = useState(false);
    const [errorestadisticasTrabajosNoEntregados, setErrorestadisticasTrabajosNoEntregados] = useState(null);

    //pagos pendientes de clientes
    const [estadistigasPagosPendientes, setestadistigasPagosPendientes] = useState([]);
    const [LoadingestadistigasPagosPendientes, setLoadingestadistigasPagosPendientes] = useState(false);
    const [errorestadistigasPagosPendientes, setErrorestadistigasPagosPendientes] = useState(null);

    //estadsiticas de asesorias no entregadas
    const [estadistigasAsesoriasPendientes, setestadistigasAsesoriasPendientess] = useState([]);
    const [LoadingestadistigasAsesoriasPendientes, setLoadingestadistigasAsesoriasPendientes] = useState(false);
    const [errorestadistigasAsesoriasPendientes, setErrorestadistigasAsesoriasPendientes] = useState(null);

    //plataforma cargada
    const [datosplataforma, setdatosplataformas] = useState([]);
    const [Loadingdatosplataforma, setLoadingdatosplataforma] = useState(false);
    const [errordatosplataforma, seterrordatosplataforma] = useState(null);

    //solicitudes con pagos para agendar
    const [solicitudPorAgendar, setsolicitudPorAgendar] = useState([]);
    const [LoadingsolicitudPorAgendar, setLoadingdatosolicitudPorAgendar] = useState(false);
    const [errorsolicitudPorAgendar, seterrorsolicitudPorAgendar] = useState(null);

    //servicios por revisar
    const [serviciosPorRevisar, setserviciosPorRevisar] = useState([]);
    const [LoadingserviciosPorRevisar, setLoadingserviciosPorRevisar] = useState(false);
    const [errorserviciosPorRevisar, seterrorserviciosPorRevisar] = useState(null);

    //sistema de referidos
    const [estadisticasReferidos, setestadisticasReferidos] = useState();
    const [loadingestadisticasReferidos, setLoadingestadisticasReferidos] = useState(true);
    const [errorestadisticasReferidos, setErrorestadisticasReferidos] = useState(null); 



    const cargarEstadisticasProUnad = async (nombreEmpresa, semestre) =>{
        try{
            setLoadingestadisticasProUnad(true);
            setErrorestadisticasProUnad(null);

            const response = await DashboardApi.estadisticasClientesProUnad(nombreEmpresa,semestre);

            const data = response.data;
            console.log("response data",data);
            //convertir solo la fecha

            const datosConFechasArregladas = data.map(cliente => {
                // Para cada cliente, mapeamos su array de próximas entregas
                const entregasConFechasCorregidas = cliente.proximasEntregas.map(entrega => {
                    // Devolvemos una copia de la entrega, pero con la fecha ya convertida
                    return {
                    ...entrega, // Mantenemos las otras propiedades (ej. 'codigo')
                    fechaEntrega: convertirFechaFirebase(entrega.fechaEntrega)
                    };
                });

                // Devolvemos una copia del cliente, pero con su lista de entregas ya corregida
                return {
                    ...cliente, // Mantenemos las otras propiedades del cliente
                    proximasEntregas: entregasConFechasCorregidas
                };
            });

            setestadisticasProUnad(datosConFechasArregladas);
            
        }
        catch(error){
            setErrorestadisticasProUnad('Error al cargar las estadisticas de proUnad: ' + error.message);
        }
        finally{
            setLoadingestadisticasProUnad(false);
        }
    };

    const cargarEstadisticasServiciosNoEntregados = async(nombreEmpresa) =>{
        try{
            setLoadingestadisticasTrabajosNoEntregados(true);
            setErrorestadisticasTrabajosNoEntregados(null);

            const response = await DashboardApi.estadisticasTrabajosNoEntregados(nombreEmpresa);

            const data = response.data.data;
            const dataConvertida = Object.values(data);

            const serviciosObj = dataConvertida.map(item => ServicioAgendado.fromJson(item));


            console.log("response data trabajos no entregados",data);

            setestadisticasTrabajosNoEntregados(serviciosObj);
        }
        catch(error){
            setErrorestadisticasTrabajosNoEntregados('Error al cargar las estadisticas de servicios no entregados: ' + error.message);
        }
        finally{
            setLoadingestadisticasTrabajosNoEntregados(false);
        }
    }

    const cargarEstadisticasPagosPendientes = async(nombreEmpresa) =>{
        try{
            setLoadingestadistigasPagosPendientes(true);
            setErrorestadistigasPagosPendientes(null);

            const response = await DashboardApi.estadisticasPagosPendientes(nombreEmpresa);

            const data = response.data.data;
            console.log("response data pagos pendientes",data);

            setestadistigasPagosPendientes(data);
        }
        catch(error){
            setErrorestadistigasPagosPendientes('Error al cargar las estadisticas de servicios no entregados: ' + error.message);
        }
        finally{
            setLoadingestadistigasPagosPendientes(false);
        }
    }

    const cargarEstadisticasAsesorias = async(nombreEmpresa) =>{
        try{
            setLoadingestadistigasAsesoriasPendientes(true);
            setErrorestadistigasAsesoriasPendientes(null);

            const response = await DashboardApi.estadisticasAsesoriasSinEnlace(nombreEmpresa);

            const data = response.data.data;
            setestadistigasAsesoriasPendientess(data);
        }
        catch(error){

        }
        finally{
             setLoadingestadistigasAsesoriasPendientes(false);
        }
    }

    //cargar toda una plataforma
    const cargarDashboardPlataforma = async(nombreEmpresa, plataforma) =>{
        try{
            setLoadingdatosplataforma(true);
            seterrordatosplataforma(null);

            const response = await DashboardApi.obntenerPlataforma(nombreEmpresa,plataforma);

            const data = response.data;
            setdatosplataformas(data);

        }
        catch(error){

        }
        finally{
            setLoadingdatosplataforma(false);
        }
    }

    //cargar solicitudes por agendar
    const cargarsolicitudesPorAgendar = async(nombreEmpresa) =>{
        try{
            setLoadingdatosolicitudPorAgendar(true);
            seterrorsolicitudPorAgendar(null);

            const response = await DashboardApi.getServiciosPorAgendar(nombreEmpresa);
            
            const data = response.data.data;
            console.log("la data obtenida",data);
            setsolicitudPorAgendar(data);
        }
        catch(error){

        }
        finally{
            setLoadingdatosolicitudPorAgendar(false);
        }
    }

    //cargar revisiones
    const cargarServiciosRevision = async(nombreEmpresa, nombreTutor = null) =>{
        console.log("cargando servicios de revision");
        try{
            setLoadingserviciosPorRevisar(true);
            seterrorserviciosPorRevisar(null);

            console.log("a ejecutar");
            const response = await DashboardApi.getServiciosPorRevisar(nombreEmpresa,nombreTutor);
            console.log("ejecutao",response);
            
            const data = response.data.data;
            console.log("data lenght",data.length);
            console.log("data data",data);
            setserviciosPorRevisar(data);
        }
        catch(error){
            console.error("error en revision",error);
        }
        finally{
            setLoadingserviciosPorRevisar(false);
        }
    }

    //estadisticas de referidos
    const cargarEstadisticasReferidos = async(nombreEmpresa) =>{
        try{
            setLoadingestadisticasReferidos(true);
            const data = await DashboardApi.getPagosReferidos(nombreEmpresa);
            console.log("cargar estadisticas refgereidos cargarEstadisticasReferidos",data);
            setestadisticasReferidos(data);
            setErrorestadisticasReferidos(null);
            return data;
        }
        catch(error){
            console.error("Error al obtener estadisticas:", error);
            setErrorestadisticasReferidos(error.message || "Error al cargar las estadsiticas");
            return null;
        }
        finally{
            setLoadingestadisticasReferidos(false);
        }
    }
    
    return{
        //dashboard proUNAD
        estadisticasProUnad,
        LoadingestadisticasProUnad,
        errorestadisticasProUnad,
        cargarEstadisticasProUnad,

        //trabajos no entregados
        estadisticasTrabajosNoEntregados,
        LoadingestadisticasTrabajosNoEntregados,
        errorestadisticasTrabajosNoEntregados,
        cargarEstadisticasServiciosNoEntregados,

        //pagos
        estadistigasPagosPendientes,
        LoadingestadistigasPagosPendientes,
        errorestadistigasPagosPendientes,
        cargarEstadisticasPagosPendientes,

        //asesorias
        estadistigasAsesoriasPendientes,
        LoadingestadistigasAsesoriasPendientes,
        errorestadistigasAsesoriasPendientes,
        cargarEstadisticasAsesorias,

        //dashboard de plataforma
        datosplataforma,
        Loadingdatosplataforma,
        errordatosplataforma,
        cargarDashboardPlataforma,

        //servicios por agendar
        cargarsolicitudesPorAgendar,
        solicitudPorAgendar,
        LoadingsolicitudPorAgendar,
        errorsolicitudPorAgendar,
        
        //servicios por revisar
        cargarServiciosRevision,
        serviciosPorRevisar,
        LoadingserviciosPorRevisar,
        errorserviciosPorRevisar,

        //estadisticas de referidos
        estadisticasReferidos,
        loadingestadisticasReferidos,
        errorestadisticasReferidos,
        cargarEstadisticasReferidos
    }

}